import { ONE_STEP_AHEAD } from '../../core/preview';

export default function OneStepAheadDetails({ onOpen }: { onOpen?: () => void }) {
  return <details className="preview-program-details" onToggle={event => { if (event.currentTarget.open) onOpen?.(); }}>
    <summary>Learn more about One Step Ahead</summary>
    <p>{ONE_STEP_AHEAD.summary}</p>
  </details>;
}
